import { useEffect, useState } from "react";
import { paymentOptions } from "../../../../../utils/constants";
import { SelectOptions } from "./SelectOptions";
import CryptoSummary from "./summary";
import { useSelector } from "react-redux";

export default function CryptoPayementFLow2({
  amount,
  setActive,
  active,
  flow,
  cryptoCurrency: selectedCurrency,
  setShowKytBlocked,
  setShowKyt,
}) {
  const currencies = useSelector(({ currencies }) => currencies?.currencies);
  const [cryptoCurrency, setCryptoCurrency] = useState({});
  useEffect(() => {
    setCryptoCurrency(selectedCurrency || currencies?.[0])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrency])
  if (flow === paymentOptions.crypto3 && active === 2) {
    return (
      <SelectOptions
        amount={amount}
        setActive={setActive}
        active={active}
        cryptoCurrency={cryptoCurrency}
        setCryptoCurrency={setCryptoCurrency}
      />
    );
  }
  if (
    (flow === paymentOptions.crypto2 && active === 2) ||
    (flow === paymentOptions.crypto3 && active === 3) || (flow === paymentOptions.crypto2 && active === 3) ||
      (flow === paymentOptions.crypto3 && active === 4)
  ) {
    return (
      <CryptoSummary
        setActive={setActive}
        active={active}
        flow={flow}
        setShowKyt={setShowKyt}
        setShowKytBlocked={setShowKytBlocked}
        amount={amount}
        cryptoCurrency={cryptoCurrency}
      />
    );
  }
}
